import { useCallback, useState } from 'react'
import { useGetMentions } from '../../hooks/useGetMentions'
import { useMarkMentionsResolved } from '../../hooks/useMarkMentionsResolved'
import { MentionListDesktopView } from './MentionListDesktopView'
import { MentionListMobileView } from './MentionListMobileView'

export const MentionsList = ({ isMobile }: { isMobile: boolean }) => {
  const [showResolved, setShowResolved] = useState(false)
  const { mutateAsync: markResolved } = useMarkMentionsResolved()

  const {
    data: unresolvedData,
    isLoading: resolvedLoading,
    refetch: refetchUnresolvedMentions,
  } = useGetMentions({ isResolved: false })
  const unresolvedMentions = unresolvedData?.mentions
  const {
    data: resolvedData,
    isLoading: unresolvedLoading,
    refetch: refetchResolvedMentions,
  } = useGetMentions({ isResolved: true })
  const resolvedMentions = resolvedData?.mentions

  const loading = resolvedLoading || unresolvedLoading
  const unresolvedMentionsCount = unresolvedMentions?.length ?? 0
  const displayedMentions = showResolved ? resolvedMentions : unresolvedMentions
  const displayedMentionCount = showResolved ? resolvedData?.totalCount : unresolvedData?.totalCount

  const markAllMentionsResolved = useCallback(
    () =>
      unresolvedMentions &&
      markResolved({
        mentions: unresolvedMentions.map((m) => ({ mentionId: m.id, requestId: m.requestId })),
        isResolved: true,
      }),
    [markResolved, unresolvedMentions]
  )

  return isMobile ? (
    <MentionListMobileView
      loading={loading}
      unresolvedMentionsCount={unresolvedMentionsCount}
      setShowResolved={setShowResolved}
      showResolved={showResolved}
      markAllMentionsResolved={markAllMentionsResolved}
      displayedMentions={displayedMentions}
      refetchResolvedMentions={refetchResolvedMentions}
      displayedMentionCount={displayedMentionCount}
      refetchUnresolvedMentions={refetchUnresolvedMentions}
    />
  ) : (
    <MentionListDesktopView
      loading={loading}
      unresolvedMentionsCount={unresolvedMentionsCount}
      setShowResolved={setShowResolved}
      showResolved={showResolved}
      markAllMentionsResolved={markAllMentionsResolved}
      displayedMentions={displayedMentions}
      refetchResolvedMentions={refetchResolvedMentions}
      displayedMentionCount={displayedMentionCount}
      refetchUnresolvedMentions={refetchUnresolvedMentions}
    />
  )
}
